import React, { useState } from 'react';

// Static Instagram feed — images refreshed periodically.
const instagramPosts = [
  { image: '/images/instagram/ig01.jpg', alt: 'Windy Hill Weavers Instagram post' },
  { image: '/images/instagram/ig02.jpg', alt: 'Windy Hill Weavers Instagram post' },
  { image: '/images/instagram/ig03.jpg', alt: 'Windy Hill Weavers Instagram post' },
  { image: '/images/instagram/ig04.jpg', alt: 'Windy Hill Weavers Instagram post' },
  { image: '/images/instagram/ig05.jpg', alt: 'Windy Hill Weavers Instagram post' },
  { image: '/images/instagram/ig06.jpg', alt: 'Windy Hill Weavers Instagram post' },
  { image: '/images/instagram/ig07.jpg', alt: 'Windy Hill Weavers Instagram post' },
  { image: '/images/instagram/ig08.jpg', alt: 'Windy Hill Weavers Instagram post' },
];

function InstagramFeed() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setStatus('sending');

    try {
      // Previous: await fetch('https://madesimpl-form-worker.paul4718.workers.dev', ...)
      const res = await fetch('https://madesim.pl/api/newsletter/subscribe', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email.trim() }),
      });

      if (!res.ok) throw new Error('Send failed');
      setStatus('sent');
      setEmail('');
    } catch {
      setStatus('error');
    }
  };

  return (
    <section className="section instagram-section" id="instagram">
      <div className="instagram-block">
        <div className="instagram-header">
          <a
            href="https://www.instagram.com/windyhillweavers/"
            target="_blank"
            rel="noopener noreferrer"
            className="instagram-follow-link"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <defs>
                <linearGradient id="ig-feed-gradient" x1="0%" y1="100%" x2="100%" y2="0%">
                  <stop offset="0%" stopColor="#feda75"/>
                  <stop offset="20%" stopColor="#fa7e1e"/>
                  <stop offset="45%" stopColor="#d62976"/>
                  <stop offset="70%" stopColor="#962fbf"/>
                  <stop offset="100%" stopColor="#4f5bd5"/>
                </linearGradient>
              </defs>
              <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" fill="url(#ig-feed-gradient)"/>
            </svg>
            Follow Windy Hill Weavers on Instagram
          </a>
        </div>
        <div className="instagram-grid">
          {instagramPosts.map((post, i) => (
            <a
              key={i}
              href="https://www.instagram.com/windyhillweavers/"
              target="_blank"
              rel="noopener noreferrer"
              className="instagram-item"
            >
              <img src={post.image} alt={post.alt} loading="lazy" />
            </a>
          ))}
        </div>
        <div className="instagram-newsletter">
          {status === 'sent' ? (
            <p className="newsletter-success">You're on the list. Thank you!</p>
          ) : (
            <>
              <p className="instagram-newsletter-text">
                Join my email list for news of upcoming shows and events.
              </p>
              <form className="instagram-newsletter-form" onSubmit={handleSubmit}>
                <input
                  type="email"
                  placeholder="Your email address"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
                <button type="submit" disabled={status === 'sending'}>
                  {status === 'sending' ? 'Joining…' : 'Subscribe'}
                </button>
              </form>
            </>
          )}
          {status === 'error' && (
            <p className="newsletter-error">Something went wrong. Please try again.</p>
          )}
        </div>
      </div>
    </section>
  );
}

export default InstagramFeed;
